import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { MoneyCell } from 'molecules';

import * as S from '../../FakturowniaInvoices/FakturowniaInvoices.styled';
import * as L from '../StudentDetail.styled';
import { IStudent } from './types';

interface IAccountsPayableBlockProps {
  student: IStudent;
}

/**
 * «Накладные обязательства» — accounts payable carried over from a previous
 * agreement (typical: student switched from group A to group B and the
 * unpaid tail moved to the new contract). Hidden when there are none.
 */
export const AccountsPayableBlock = memo(
  ({ student }: IAccountsPayableBlockProps) => {
    const { t } = useTranslation();
    const rows = student.accountsPayables || [];

    if (rows.length === 0) return null;

    return (
      <S.Card>
        <S.CardTitle>
          {t('pages.studentDetail.accountsPayable.title')}
        </S.CardTitle>
        <L.SmallTable>
          <thead>
            <tr>
              <th>{t('pages.studentDetail.accountsPayable.from')}</th>
              <th style={{ textAlign: 'right' }}>
                {t('pages.studentDetail.accountsPayable.amount')}
              </th>
              <th>{t('pages.studentDetail.accountsPayable.repaidLabel')}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((p) =>
              p ? (
                <tr key={p.id}>
                  <td>{p.startedAgreement?.agreementTitle || '—'}</td>
                  <td style={{ textAlign: 'right' }}>
                    <MoneyCell
                      amount={p.amountForeign ?? null}
                      currency={p.currency || ''}
                    />
                  </td>
                  <td>
                    {p.repaid ? (
                      <L.Tag tone="ok">
                        {t('pages.studentDetail.accountsPayable.repaid')}
                      </L.Tag>
                    ) : (
                      <L.Tag tone="warn">
                        {t('pages.studentDetail.accountsPayable.outstanding')}
                      </L.Tag>
                    )}
                  </td>
                </tr>
              ) : null,
            )}
          </tbody>
        </L.SmallTable>
      </S.Card>
    );
  },
);
